import createSvgIcon from '@mui/material/utils/createSvgIcon'

const Template2 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="currentColor">
    <path d="M0.5 8V3.5C0.5 2.675 0.79375 1.96875 1.38125 1.38125C1.96875 0.79375 2.675 0.5 3.5 0.5H24.5C25.325 0.5 26.0313 0.79375 26.6188 1.38125C27.2063 1.96875 27.5 2.675 27.5 3.5V8H0.5ZM3.5 27.5C2.675 27.5 1.96875 27.2063 1.38125 26.6188C0.79375 26.0313 0.5 25.325 0.5 24.5V11H7.25V27.5H3.5ZM20.75 27.5V11H27.5V24.5C27.5 25.325 27.2063 26.0313 26.6188 26.6188C26.0313 27.2063 25.325 27.5 24.5 27.5H20.75ZM10.25 27.5V11H17.75V27.5H10.25Z" />
  </svg>,
  'Template2'
)

export default Template2
